<template>
  <div>
    <div class="list-view-detail">
      <cell-logger-wrapper-search-list
        v-for="(cell, index) in cellList"
        :key="`list_cell_${index}`"
        :cell-info="cell"
        :index="index"
      >
        <template #clickable-cell>
          <component
            :is="thumbnailInfo.componentName"
            :cell-info="cell"
            :thumbnail-info="thumbnailInfo"
            :search-word="searchWord"
          />
        </template>
      </cell-logger-wrapper-search-list>
    </div>
    <div ref="scrollMonitor" />
  </div>
</template>

<script>
import scrollMonitor from 'scrollmonitor'
import CircleCell from '@/components/model/cell/CircleCell'
import LandscapeCell from '@/components/model/cell/LandscapeCell'
import PortraitCell from '@/components/model/cell/PortraitCell'
import CellLoggerWrapperSearchList from '@/components/model/cellWrapper/CellLoggerWrapperSearchList'

export default {
  name: 'SearchKeywordResultList',
  components: {
    CellLoggerWrapperSearchList,
    CircleCell,
    LandscapeCell,
    PortraitCell
  },
  props: {
    cellList: {
      type: Array,
      default: null
    },
    thumbnailInfo: {
      type: Object,
      default: () => ({})
    },
    searchWord: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      watcher: null
    }
  },
  mounted () {
    const monitorEl = this.$refs['scrollMonitor']
    this.watcher = scrollMonitor.create(monitorEl, 100)
    this.watcher.enterViewport(this.emitDataLoadMore)
  },
  beforeDestroy () {
    this.watcher.destroy()
  },
  methods: {
    emitDataLoadMore () {
      return this.$emit('load-more-fn')
    }
  }
}
</script>
